import { OBJECT_TYPES } from 'src/tpbp-configuration/models/models.const'
import type { PersonModel } from 'src/tpbp-json-api-handler/models/models'
import {
  getRules,
  getSchema,
  initConfigurationIfNecessary,
} from 'src/tpbp-json-api-handler/utils/ApiStore'
import type { ProxyRecord } from './deserializers/deserializers.types'
import type { RequestService } from './request.types'

export function initPersonConfigurationIfNecessary(service: RequestService) {
  return initConfigurationIfNecessary(OBJECT_TYPES.person, service)
}

export function getPersonSchema(record: PersonModel) {
  return getSchema(record)
}

export function getPersonRules(record: ProxyRecord) {
  return getRules(record)
}
